import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar, Splashscreen } from 'ionic-native';
import { AngularFire } from 'angularfire2';
import { TabsPage } from '../pages/tabs/tabs';
import { NavPage} from '../pages/nav/nav';
import {appState } from "../model/appState";
import {person, personModel } from "../model/personModel";
import {personPage} from '../pages/person/person';
import { settingsPage } from '../pages/settings/settings';
import {  } from "neel-login/login.page.html";

declare var FB: any;
@Component({
  templateUrl: 'app.html'
})
export class MyApp {    
    rootPage:any = NavPage;
    loginOk = false;
    constructor(
        platform: Platform,
        public af: AngularFire,
        private _appState: appState,
        private perModel: personModel
    ) {
        var that = this;        
        platform.ready().then(() => {               
           /* FB.getLoginStatus(function (response) {
                that.statusChangeCallback(response);
            });  
            FB.Event.subscribe('auth.login', function (response) {
                that.login(response);
            });
            FB.Event.subscribe('auth.logout', function (response) {
                that.logout(response);
            });
            FB.Event.subscribe('auth.statusChange', function (response) {
                that.statusChange(response);
            });            */
        });
    }
    
    statusChange(response) {
        var that = this;
        console.log(response);
        if (response != null && response.status == 'connected' && response.authResponse.userID != null) {
            console.log(response);
            that.rootPage = settingsPage;
        } else {
            that.rootPage = personPage;
            FB.login(function (response) { console.log(response); });
        }
    }  
    login(response) {
        console.log(response);
    }
    logout(response) {
        console.log(response);
    }
    statusChangeCallback(response) {
        var that = this;
        StatusBar.styleDefault();
        //Splashscreen.hide();
        Splashscreen.show();
        this.af.auth.login();
        this.af.auth.subscribe(auth => {
            that._appState.auth = auth;
            that.perModel.meRef.subscribe(function (obj) {
                var me: any = obj;

                if (me != null)
                    if (me.name != null && me.name != undefined && me.name != 'Name')
                        if (me.name.length >= 3)
                            that.loginOk = true;
                        else
                            that.loginOk = false;
                    else
                        that.loginOk = false;
                else
                    that.loginOk = false;
            },
                function (err) { console.log(err); }
            );
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts